<template>
  <form
    v-if="user.profile && CEventSignature?.secureSignature && CEventSignature?.timestamp"
    ref="cventForm"
    :action="$feature.configCeventDomain"
    class="hidden"
    method="POST"
    target="_blank"
  >
    <input name="ecode" type="hidden" :value="ecode">
    <input name="first_name" type="hidden" :value="user.profile.consumerDetails.firstName">
    <input name="last_name" type="hidden" :value="user.profile.consumerDetails.lastName">
    <input name="email_address" type="hidden" :value="user.profile.consumerDetails.email">
    <input name="source_id" type="hidden" :value="user.profile.consumerDetails.consumerId">
    <input name="target" type="hidden" value="Registration">
    <input name="reg_signature" type="hidden" :value="CEventSignature.secureSignature">
    <input name="timestamp" type="hidden" :value="CEventSignature.timestamp">
  </form>

  <cms-base-button-simple
    v-bind="props"
    @click="handleAction()"
  />
</template>

<script lang="ts" setup>
import type { CEventResponse } from '#types/cevent'
import type { TargetCvent } from '#types/target'

const props = defineProps<TargetCvent>()

const auth = useAuthStore()
const user = useUserStore()
const { DialogSignIn } = useDialogsStore()

const CEventSignature = ref<CEventResponse>()
const form = useTemplateRef('cventForm')

const { ecode } = props.actionLink || {}

const handleAction = () => {
  if (auth.loggedIn) {
    form.value?.submit()
  }
  else {
    DialogSignIn.open({ formLocation: 'modal:single:pop-up:none' })
  }
}

watchImmediate([() => user?.profile?.consumerDetails?.email], async ([email]) => {
  if (email) {
    try {
      CEventSignature.value = await $fetch<CEventResponse>('/edge/get-cevent-secure-signature', {
        method: 'POST',
        body: { email }
      })
    }
    catch (err) {
      log.info(err)
    }
  }
})
</script>
